import { gql } from '@apollo/client'

export default gql(`
    mutation updateUser($accessRoleGroups: [ID] $id: String $name: String $project: String $ip: [String]) {
        updateUser(
            input: {
                id: $id
                name: $name
                accessRoleGroups: $accessRoleGroups
                ip: $ip
            }
            project: $project
        ){
            id
            status
            name
            enabled
            status
            lastLogin
            ip
            accessRoleGroups {
              id
              name
              modules{
                name
                permissions
              }
            }
        }
    }
`)
